// Derivation du navigateur a partir du user-agent.
//
// Le plugin envoie `browser_name`/`browser_version` deja parses (heartbeat.js),
// mais les versions <= juin 2026 detectaient Edge/Opera comme "Chrome" (leur UA
// contient "Chrome/<v>...Edg/<v>"). On re-derive donc cote admin depuis le
// `user_agent` brut — toujours transmis — pour corriger l'affichage sans
// attendre le rollout Web Store du plugin corrige.

export interface ParsedBrowser {
  name: string;
  version: string;
}

// ORDRE IMPORTANT : Edge et Opera embarquent "Chrome/<v>" dans leur UA, il faut
// donc les tester AVANT Chrome. De meme Chrome contient "Safari/537.36".
export function parseBrowser(userAgent: string | null | undefined): ParsedBrowser | null {
  if (!userAgent) return null;
  const ua = userAgent;

  const match = (re: RegExp): string => {
    const m = ua.match(re);
    return m && m[1] ? m[1] : "";
  };

  if (ua.indexOf("Firefox") > -1) {
    return { name: "Firefox", version: match(/Firefox\/(\d+)/) };
  }
  if (ua.indexOf("Edg/") > -1 || ua.indexOf("EdgA/") > -1 || ua.indexOf("EdgiOS/") > -1) {
    return { name: "Edge", version: match(/Edg(?:A|iOS)?\/(\d+)/) };
  }
  if (ua.indexOf("OPR/") > -1 || ua.indexOf("Opera") > -1) {
    return { name: "Opera", version: match(/(?:OPR|Opera)\/(\d+)/) };
  }
  if (ua.indexOf("Chrome") > -1) {
    return { name: "Chrome", version: match(/Chrome\/(\d+)/) };
  }
  if (ua.indexOf("Safari") > -1) {
    return { name: "Safari", version: match(/Version\/(\d+)/) };
  }
  if (ua.indexOf("MSIE") > -1 || ua.indexOf("Trident") > -1) {
    return { name: "IE", version: match(/(?:MSIE |rv:)(\d+)/) };
  }
  return null;
}

/**
 * Libelle navigateur a afficher. Prefere la re-derivation depuis le user-agent
 * (corrige Edge/Opera mal detectes), retombe sur les champs `browser_name`/
 * `browser_version` du heartbeat si l'UA est absent ou non reconnu.
 */
export function formatBrowser(
  userAgent: string | null | undefined,
  fallbackName?: string | null,
  fallbackVersion?: string | null,
): string {
  const parsed = parseBrowser(userAgent);
  const name = parsed?.name || fallbackName || "";
  const version = parsed?.version || fallbackVersion || "";
  return `${name} ${version}`.trim() || "—";
}
